export const RETURN_URL_UNLOGGED_CHECKOUT = '/checkout'
